import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FaEllipsisV } from 'react-icons/fa';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { toast } from 'react-toastify';

const GroupStudentList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [students, setStudents] = useState([]);
  const { slug } = useParams();

  const [responce, loading, error, callAPI] = useApiCallHooks();

  useEffect(() => {
    if (slug) {
      callAPI('get', `mentor/group-student-list/${slug}`);
    }
  }, [slug]);

  useEffect(() => {
    if (responce?.data) {
      // ✅ Extract only student objects
      const mapped = responce.data.map(item => ({
        id: item.student.id,
        first_name: item.student.first_name,
        last_name: item.student.last_name,
        email: item.student.email,
mobile: item.student.mobile_no,   // ✅ Correct field
  image: item.student.profile_pic, // ✅ Correct field

        program: item.student.program,
        slug: item.student.slug,
      }));
      setStudents(mapped);
    }
   
  }, [responce, error]);

  const filteredStudents = students.filter(student =>
    `${student.first_name} ${student.last_name}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
    student.program?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    student.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AdminAppBody
    loading={loading}
      content={
        <div className="container mt-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Student List</h4>
            <div className="input-group w-25">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
            </div>
          </div>

          <table className="table table-bordered table-hover">
            <thead className="table-primary">
              <tr>
                <th>Sr No</th>
                <th>Student Name</th>
                <th>Program</th>
                <th>Email</th>
                <th>Mobile No</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudents.length > 0 ? (
                filteredStudents.map((student, idx) => (
                  <tr key={student.id}>
                    <td>{idx + 1}</td>
                    <td className="d-flex align-items-center gap-2">
                      {student.image ? (
                        <img
                          src={student.image}
                          alt="profile"
                          className="rounded-circle"
                          width="35"
                          height="35"
                        />
                      ) : (
                        <div
                          className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center"
                          style={{ width: 35, height: 35 }}
                        >
                          <i className="bi bi-person"></i>
                        </div>
                      )}
                      <span>{student.first_name} {student.last_name}</span>
                    </td>
                    <td>{student.program || '-'}</td>
                    <td>{student.email || '-'}</td>
                    <td>{student.mobile|| '-'}</td>
                   
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No students found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      }
    />
  );
};

export default GroupStudentList;
